import { render } from "./about_us.vue?vue&type=template&id=6b71f2cf&scoped=true"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"

import "./about_us.vue?vue&type=style&index=0&id=6b71f2cf&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b71f2cf"]])

export default __exports__